import { render } from "./ListeParametre.vue?vue&type=template&id=879db564&ts=true"
import script from "./ListeParametre.vue?vue&type=script&lang=ts"
export * from "./ListeParametre.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__